/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import React from "react";
import Navbar from "react-bootstrap/Navbar";

import { useIsAuthenticated } from "@azure/msal-react";
// import { SignInButton } from "./SignInButton";
// import { SignOutButton } from "./SignOutButton";

/**
 * Renders the navbar component with a sign-in or sign-out button depending on whether or not a user is authenticated
 * @param props 
 */

//Added Device type for changing HTML display content.
export const PageLayout = (props) => {
    console.log(props);
    const isAuthenticated = useIsAuthenticated();

    return (
        <>
            <Navbar style={{backgroundColor: "#0071c5"}}>
                {/* <a className="navbar-brand" href="/">Intel Mobile Registration</a> */}
                <div>
                    &nbsp;<img className="img-fluid pull-left navbar-logo" src="/Intel-Logo.png" alt="Intel Logo" style={{width:"12%",height:"auto"}} />
                    <div style={{display:"inline-block", color:"#fff", verticalAlign: "bottom"}}>
                        <span style={{fontSize: "medium"}}>Provided by Intel IT</span> <br/>
                        {(props.deviceType == 'mobile')?(
                                <span style={{fontSize: "xx-large"}}>Mobile Enrollment</span>
                        ):((props.deviceType == 'mac')?(<span style={{fontSize: "xx-large"}}>Mac Enrollment</span>):
                        (<span style={{fontSize: "xx-large"}}>Device Enrollment</span>))}
                    </div>
                </div>
            </Navbar>
            {/* <div style={{textAlign:"center",fontSize:"larger",width:"100%",backgroundColor:"#003C71",color:"#fff",flexWrap:"wrap",paddingRight:"calc(var(--bs-gutter-x)*.5)",paddingLeft:"calc(var(--bs-gutter-x)*.5)",marginTop:"var(--bs-gutter-y)"}}>
                <span>Mobile Device Enrollment Access Request</span>
            </div> */}
            {/* <div style={{textAlign:"center",fontSize:"xx-large",width:"100%",fontWeight: "bold", marginTop:"var(--bs-gutter-y)", paddingRight:"calc(var(--bs-gutter-x)*.5)",paddingLeft:"calc(var(--bs-gutter-x)*.5)", paddingTop:"1.5rem"}}>
                <span>Mobile Device Enrollment Access Request</span>
            </div> */}
            <br />
            {props.children}
        </>
    );
};
